import { render, staticRenderFns } from "./ModalAddPlan.vue?vue&type=template&id=174b27a6&scoped=true&"
import script from "./ModalAddPlan.vue?vue&type=script&lang=js&"
export * from "./ModalAddPlan.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddPlan.vue?vue&type=style&index=0&id=174b27a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174b27a6",
  null
  
)

export default component.exports